// utils/dateFormatter.js
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

export const formatDate = (date) => {
  if (!date) return "Recently";
  
  const now = dayjs();
  const inputDate = dayjs(date);
  
  // If date is today, show time
  if (inputDate.isSame(now, 'day')) {
    return `Today at ${inputDate.format('hh:mm A')}`;
  }
  
  // If date is yesterday
  if (inputDate.isSame(now.subtract(1, 'day'), 'day')) {
    return `Yesterday at ${inputDate.format('hh:mm A')}`;
  }
  
  // If within last 7 days, show day name
  if (inputDate.isAfter(now.subtract(7, 'day'))) {
    return inputDate.format('dddd');
  }
  
  // If within last 30 days, show relative time
  if (inputDate.isAfter(now.subtract(30, 'day'))) {
    return inputDate.fromNow();
  }
  
  // For older dates, show formatted date
  return inputDate.format('DD MMM YYYY');
};
